module.exports = __webpack_public_path__ + "img/thumb-alex.3a032bd7.png";